import api from '../../Services/API';

// OBTÉM A LISTA DOS ARTIGOS DA ORDEM DE FABRICO \ YWFORARTOF
export async function postCarrinho(body) {
    const token = localStorage.getItem('token');
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            'content-type': 'application/json',
        },
    };

    return api.post(`backend/catalogo/Encomenda/`, body, config).then(res => {
        return res;
    });
}
